import React, { FC, useCallback, useMemo, useState } from 'react';

import { AppCol } from 'components/appComponents';
import { TabPanel } from 'devextreme-react';

import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

import ComingNomenclatureTransport from '../ComingNomenclatureTransport';
import { NomenclatureTransferForm } from '../NomenclatureTransferForm';

type Props = {
  dataNomenclatureTransfer: NomenclatureTransfer;
  isLoadingSubmit: boolean;
  onSubmit: (form: NomenclatureTransfer) => void;
};

export const NomenclatureTransferDetailPage: FC<Props> = ({ onSubmit, dataNomenclatureTransfer, isLoadingSubmit }) => {
  const [activeTab, setActiveTab] = useState(0);

  const itemTitleRender = (tab: { name: string; index: number }) => {
    return <span>{tab.name}</span>;
  };

  const tabs = useMemo(
    () => [
      {
        name: 'Основная информация',
        index: 0,
      },
      {
        name: 'Список машин',
        index: 1,
      },
    ],
    [],
  );

  const handleSelectionChanged = useCallback((e: any) => {
    setActiveTab(e.addedItems![0].index);
  }, []);

  return (
    <div>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={activeTab}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
        onSelectionChanged={handleSelectionChanged}
      />
      {activeTab === 0 && (
        <div className="tab-content">
          <AppCol col={8}>
            <NomenclatureTransferForm
              onSubmit={onSubmit}
              loading={isLoadingSubmit}
              dataNomenclatureTransfer={dataNomenclatureTransfer}
            />
          </AppCol>
        </div>
      )}
      {activeTab === 1 && (
        <div className="tab-content">
          <ComingNomenclatureTransport />
        </div>
      )}
    </div>
  );
};
